import React from 'react';
import {
  arrayOf, bool, func, number, string
} from 'prop-types';
import classNames from 'classnames';
import { Col } from '@thd-olt-component-react/core-ui';

const MIN_AREA_NUMBER = 1;

export const CalculatorWidthHeightElement = ({
  errorBoxWidth,
  errorBoxHeight,
  index,
  valueHeights,
  valueWidths,
  valueDepths,
  valueDescription,
  showDescriptions,
  lineItemName,
  calculatorType,
  dimensionNames,
  step,
  channel,
  handleChangeWidthHeight,
  removeWidthHeightElement,
  showMulchOptions,
  hideAreaText
}) => {
  const suffixWidthClassName = classNames({
    'calculator__suffix-width': channel !== 'mobile',
    'calculator__suffix-width-mobile': channel === 'mobile'
  });
  const suffixHeightClassName = classNames({
    'calculator__suffix-height': channel !== 'mobile',
    'calculator__suffix-height-mobile': channel === 'mobile'
  });
  const suffixDepthClassName = classNames({
    'calculator__suffix-depth': channel !== 'mobile',
    'calculator__suffix-depth-mobile': channel === 'mobile'
  });
  const inputClass = classNames('calculator__inputs', {
    'calculator__inputs-mulch': showMulchOptions,
    'calculator__inputs-no-padding': hideAreaText
  });
  const inputClassWidth = classNames('calculator__input-wrapper-width', 'form-input', {
    'form-input--error': errorBoxWidth
  });
  const inputClassHeight = classNames('calculator__input-wrapper-height', 'form-input', {
    'form-input--error': errorBoxHeight
  });
  const inputClassDepth = classNames('calculator__input-wrapper-depth', 'form-input');
  const inputClassHeader = classNames({
    'calculator__input-header': channel === 'desktop'
  });
  const depthColSize = showMulchOptions ? 2 : 3;
  const buttonColSize = showMulchOptions ? 1 : 3;
  const dimensions = (dimensionNames && dimensionNames.length !== 0)
    ? dimensionNames.reduce((names, currentDimension, i) => {
      const dimensionList = names;
      dimensionList['dimension' + (i + 1)] = currentDimension;
      return dimensionList;
    }, {})
    : { dimension1: 'Length', dimension2: 'Width' };
  return (
    <div key={index}>
      {!hideAreaText && (
        <div className="u__bold calculator__add-area-text">
          {`${lineItemName} ${index + 1}`}
        </div>
      )}
      <div className={inputClass}>
        {showDescriptions && (
          <Col fallback={12} xs={3} sm={3} md={3} lg={3} nopadding>
            <div className="calculator__input-wrapper-width form-input">
              <div className={inputClassHeader}>
                Description:
              </div>
              <input
                data-testid="calculator-input"
                className="form-input__field calculator__input-disable-zoom"
                min={0}
                name="description"
                onChange={(event) => handleChangeWidthHeight(event, index, false)}
                value={valueDescription[index]}
              />
            </div>
          </Col>
        )}
        <Col fallback={3} xs={3} sm={3} md={3} lg={3} nopadding>
          <div className={inputClassWidth}>
            <div className={inputClassHeader}>
              {`${dimensions.dimension1}:`}
            </div>
            <input
              className="form-input__field calculator__input-disable-zoom"
              min={0}
              onChange={(event) => handleChangeWidthHeight(event, index, false)}
              type="number"
              value={valueWidths[index]}
            />
            {!errorBoxWidth
              && (
                <span className={suffixWidthClassName}>
                  ft
                </span>
              )}
          </div>
        </Col>
        <Col fallback={3} xs={3} sm={3} md={3} lg={3} nopadding>
          <div className={inputClassHeight}>
            <div className={inputClassHeader}>
              {`${dimensions.dimension2}:`}
            </div>
            <input
              className="form-input__field calculator__input-disable-zoom"
              min={0}
              onChange={(event) => handleChangeWidthHeight(event, index, true)}
              type="number"
              value={valueHeights[index]}
            />
            {!errorBoxHeight
              && (
                <span className={suffixHeightClassName}>
                  ft
                </span>
              )}
          </div>
        </Col>
        {calculatorType === 'Volume' && (
          <Col fallback={3} xs={depthColSize} sm={depthColSize} md={depthColSize} lg={depthColSize} nopadding>
            <div className={inputClassDepth}>
              <div className={inputClassHeader}>
                Depth:
              </div>
              <input
                className="form-input__field calculator__input-disable-zoom calculator__input-wrapper-depth--field"
                min={0}
                name="depth"
                onChange={(event) => handleChangeWidthHeight(event, index, false)}
                type="number"
                value={valueDepths[index]}
              />
              <span className={suffixDepthClassName}>
                in
              </span>
              <div className="calculator__input-wrapper-depth-subtext">
                (3 in. recommended)
              </div>
            </div>
          </Col>
        )}
        <Col fallback={3} xs={buttonColSize} sm={buttonColSize} md={buttonColSize} lg={buttonColSize}>
          {step > MIN_AREA_NUMBER
            && (
              <button
                type="button"
                aria-label="Save"
                className="calculator__close-icon"
                onClick={() => removeWidthHeightElement(index)}
              />
            )}
        </Col>
      </div>
    </div>
  );
};

CalculatorWidthHeightElement.propTypes = {
  errorBoxWidth: bool.isRequired,
  errorBoxHeight: bool.isRequired,
  index: number.isRequired,
  valueHeights: arrayOf(string).isRequired,
  valueWidths: arrayOf(string).isRequired,
  valueDepths: arrayOf(string),
  step: number.isRequired,
  channel: string.isRequired,
  lineItemName: string,
  calculatorType: string,
  dimensionNames: arrayOf(string),
  handleChangeWidthHeight: func.isRequired,
  removeWidthHeightElement: func.isRequired,
  showMulchOptions: bool,
  valueDescription: arrayOf(string),
  showDescriptions: bool,
  hideAreaText: bool
};

CalculatorWidthHeightElement.defaultProps = {
  lineItemName: '',
  calculatorType: 'Area',
  dimensionNames: ['Width', 'Height'],
  valueDepths: ['3'],
  showMulchOptions: false,
  valueDescription: [''],
  showDescriptions: false,
  hideAreaText: false
};
